var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (continueBtnText, doneText, hasNarration, hasPrompt, i18n, list, prompt, submitUp, title, undefined) {
buf.push("<div class=\"content-scroll content-fill\"><div class=\"content-scroll-inner block-v-md\"><div class=\"block-v-md\"><div class=\"text-xxl text-center slide-up\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</div></div><div class=\"row block-v-md\"><div class=\"col-sm-12 col-md-10 col-md-offset-1\"><div class=\"accordion\">");
// iterate list
;(function(){
  var $$obj = list;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var item = $$obj[i];

var klass = "middle";
if (i === 0) klass = "first";
if (i === list.length - 1 ) klass = "last";
buf.push("<div" + (jade.cls(['item',"item-" + (klass) + ""], [null,true])) + "><div class=\"item-button btn btn-solid\"><div class=\"accordion-text text-start\">" + (null == (jade_interp = item.title) ? "" : jade_interp) + "</div></div><div class=\"item-content block-dk block-md\"><div class=\"text-md\">" + (null == (jade_interp = item.content) ? "" : jade_interp) + "</div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var item = $$obj[i];

var klass = "middle";
if (i === 0) klass = "first";
if (i === list.length - 1 ) klass = "last";
buf.push("<div" + (jade.cls(['item',"item-" + (klass) + ""], [null,true])) + "><div class=\"item-button btn btn-solid\"><div class=\"accordion-text text-start\">" + (null == (jade_interp = item.title) ? "" : jade_interp) + "</div></div><div class=\"item-content block-dk block-md\"><div class=\"text-md\">" + (null == (jade_interp = item.content) ? "" : jade_interp) + "</div></div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"list" in locals_for_with?locals_for_with.list:typeof list!=="undefined"?list:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}